<div [style.height]="height" class="widget-item">
  <div class="widget-body">
    <ng-content></ng-content>
  </div>
</div>
